import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../services/firebase';

/**
 * Real-time listener for the global leaderboard document.
 */
export function useLeaderboard() {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onSnapshot(
      doc(db, 'leaderboard', 'global'),
      (docSnap) => {
        if (docSnap.exists()) {
          setEntries(docSnap.data().entries || []);
        } else {
          setEntries([]);
        }
        setLoading(false);
      },
      (err) => {
        console.error('Error listening to leaderboard:', err);
        setLoading(false);
      }
    );

    return unsubscribe;
  }, []);

  return { entries, loading };
}
